import { lazy } from 'react'
import { Route, Switch } from '@hfs/react-router'
import { getRoute } from '@hfs/website/utils/getRoute'

export const HomepageRoutes = () => (
  <Switch>
    <Route
      component={lazy(async () => {
        const { Homepage } = await import(
          /* webpackPrefetch: true, webpackChunkName: "Homepage" */ '@hfs/website/react/pages/public/Homepage'
        )

        return {
          default: Homepage,
        }
      })}
      exact
      path={getRoute('/')}
    />
  </Switch>
)
